import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { fr } from 'date-fns/locale';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  MenuItem,
  InputBase,
  Dialog,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import {
  customInputRanges,
  staticRangesCustom
} from '../../../exportCommands/CommandsReport/datePickerCustom';

const BootstrapInput = withStyles(theme => ({
  input: {
    borderRadius: 16,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    }
  }
}))(InputBase);

const startOfMonth = moment()
  .startOf('month')
  .add(3, 'hours')
  .toISOString();

const periodicities = [
  {
    name: 'THIS_MONTH',
    label: 'Ce mois',
    dateFrom: startOfMonth,
    dateTo: moment(new Date()).toISOString()
  },
  {
    name: 'LAST_THREE_MONTH',
    label: '3 mois',
    dateFrom: moment()
      .subtract(2, 'month')
      .startOf('month')
      .add(3, 'hours')
      .toISOString(),

    dateTo: moment(new Date()).toISOString()
  },
  {
    name: 'LAST_SIX_MONTH',
    label: '6 mois',
    dateFrom: moment()
      .subtract(5, 'month')
      .startOf('month')
      .add(3, 'hours')
      .toISOString(),
    dateTo: moment(new Date()).toISOString()
  }
];

const PeriodicityButton = ({
  onChange,
  defaultPeriodicity = 'THIS_MONTH',
  initButtonLabelCustom = 'Personalisé'
}) => {
  const [currentPeriodicity, setCurrentPeriodicity] = useState(
    defaultPeriodicity
  );

  const [buttonLabelCustom, setButtonLabelCustom] = useState(
    initButtonLabelCustom
  );

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  });
  const [openDialog, setOpenDialog] = useState(false);
  /**
   * Function permettant de modifier le créneau d'export
   * @param  {object} date object avec les date de debut et de fin d'export
   */
  const handleDateSelection = date => {
    setSelectionRange(date.selection);
  };

  const handleChangeCustomRange = () => {
    onChange({
      name: 'CUSTOM_RANGE',
      label: 'Personalisé',
      dateFrom: moment(selectionRange.startDate)
        .add(3, 'hours')
        .toISOString(),
      dateTo: moment(selectionRange.endDate)
        .add(3, 'hours')
        .toISOString()
    });
    setButtonLabelCustom(
      `${moment(selectionRange.startDate)
        .add(3, 'hours')
        .format('L')} -
        ${moment(selectionRange.endDate)
          .add(3, 'hours')
          .format('L')}`
    );
    setOpenDialog(false);
  };

  const handleChange = event => {
    setCurrentPeriodicity(event.target.value);
    if (event.target.value === 'CUSTOM_RANGE') {
      setOpenDialog(true);
    } else {
      onChange(
        periodicities.find(
          periodicitie => periodicitie.name === event.target.value
        )
      );
      setButtonLabelCustom('Personalisé');
    }
  };

  return (
    <div>
      <FormControl variant="outlined">
        <Select
          value={currentPeriodicity}
          onChange={handleChange}
          label="Periodicity"
          input={<BootstrapInput />}
        >
          {periodicities.map(periodicitie => (
            <MenuItem value={periodicitie.name} key={periodicitie.name}>
              {periodicitie.label}
            </MenuItem>
          ))}
          <MenuItem value="CUSTOM_RANGE">{buttonLabelCustom}</MenuItem>
        </Select>
      </FormControl>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogContent>
          <DateRangePicker
            moveRangeOnFirstSelection={false}
            onChange={handleDateSelection}
            ranges={[selectionRange]}
            locale={fr}
            months={2}
            maxDate={new Date()}
            minDate={new Date('January 01, 2016')}
            direction="horizontal"
            staticRanges={staticRangesCustom}
            inputRanges={customInputRanges}
          />
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              color="secondary"
              variant="contained"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              onClick={handleChangeCustomRange}
            >
              Valider
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

PeriodicityButton.propTypes = {
  onChange: PropTypes.func,
  defaultPeriodicity: PropTypes.string,
  initButtonLabelCustom: PropTypes.string
};

export default PeriodicityButton;
